<template>
    <div class="mb-4">
        <b-row>
            <b-col md="6">
                <b-card>
                    <h4 class="strong">MD / TVD List</h4>
                    <hr />
                    <b-row>
                        <b-col md="3">
                            <b-form-text>Case OD</b-form-text>
                            <b-input ref="caseId" size="sm" type="number" step="any" v-model="caseId" />
                        </b-col>
                        <b-col md="6" v-if="type == 'Directional'">
                            <b-row>
                                <b-col sm="6">
                                    <b-form-text>MD</b-form-text>
                                    <b-input size="sm" type="number" step="any" v-model="md" />
                                </b-col>
                                <b-col sm="6">
                                    <b-form-text>TVD</b-form-text>
                                    <b-input size="sm" type="number" step="any" v-model="tvd" v-on:keyup.enter="didTapInsert" />
                                </b-col>
                            </b-row>
                        </b-col>
                        <b-col v-else md="6">
                            <b-form-text>MD / TVD</b-form-text>
                            <b-input size="sm" type="number" step="any" v-model="md" v-on:keyup.enter="didTapInsert" />
                        </b-col>
                        <b-col md="3">
                            <b-button block size="sm" variant="primary" @click="didTapInsert" style="margin-top: 22.5px">Insert</b-button>
                        </b-col>
                    </b-row>
                    <b-form-text class="mt-4">Angles will be calculated & populated after the chart is generated.</b-form-text>
                    <b-table class="alignMiddle"
                        striped hover outlined fixed small
                        show-empty
                        :items="sortedItems"
                        :fields="fields"
                    >
                        <!-- <template slot="angle" slot-scope="row">
                            <span v-if="row.item.angle == '-'">{{ row.item.angle }}</span>
                            <span v-else>{{ row.item.angle }}&deg;</span>
                        </template> -->
                        <template slot="action" slot-scope="row">
                            <b-button size="sm" variant="danger" @click="didTapRemove(row.item)">
                                <font-awesome-icon icon="times"/>
                            </b-button>
                        </template>    
                    </b-table>
                    <b-row class="mt-4">
                        <b-col md="12" style="text-align: end">
                            <b-button size="sm" variant="primary" :disabled="isGenerating" @click="didTapGenerateChart(true)">{{ isGenerating? "Generating Chart..." : "Save & Generate Chart" }}</b-button>
                        </b-col>
                    </b-row>
                </b-card>
                <b-card class="mt-4">
                    <h4 class="strong">MD / TVD Converter</h4>
                    <hr />
                    <b-form-text>
                        The MD / TVD Converter procudes estimated calculation based on the data given in MD / TVD List. Please make sure that your search query is within the minimum and maximum values of above table.
                    </b-form-text>
                    <b-row class="mt-2">
                        <b-col md="4">
                            <b-form-text>Conversion</b-form-text>
                            <b-form-select size="sm" v-model="conversion" @change="didChangeConversion">
                                <option value=0>MD to TVD</option>
                                <option value=1>TVD to MD</option>
                            </b-form-select>
                        </b-col>
                        <b-col md="4">
                            <b-form-text>{{ conversion == 0 ? "MD" : "TVD" }}</b-form-text>
                            <b-input-group>
                                <b-input size="sm" type="number" step="any" v-model="source" @keyup.enter="didTapCalculate" />
                                <b-input-group-append>
                                    <b-button size="sm" variant="primary" @click="didTapCalculate">Go</b-button>
                                </b-input-group-append>
                            </b-input-group>
                        </b-col>
                        <b-col md="4">
                            <b-form-text>{{ conversion == 0 ? "TVD" : "MD" }}</b-form-text>
                            <b-input size="sm" type="text" readonly v-model="dest" />
                        </b-col>
                    </b-row>
                </b-card>
            </b-col>
            <b-col md="6" v-if="isChartGenerated">
                <!-- <b-card>
                    <h4 class="strong">Dogleg Severity Check</h4>
                    <hr />
                    <b-row>
                        <b-col md="6">
                            <b-form-text>MD Upper</b-form-text>
                            <strong>{{ dogleg.mdUpper }}</strong> <span style="font-size: 10pt"> {{ unit }}</span>
                        </b-col>
                        <b-col md="6">
                            <b-form-text>MD Lower</b-form-text>
                            <strong>{{ dogleg.mdLower }}</strong> <span style="font-size: 10pt"> {{ unit }}</span>
                        </b-col>
                    </b-row>
                    <b-row class="mt-2">
                        <b-col md="6">
                            <b-form-text>Inclination Upper (I1)</b-form-text>
                            <strong>{{ dogleg.inclUpper }}</strong>&deg;
                        </b-col>
                        <b-col md="6">
                            <b-form-text>Inclination Lower (I2)</b-form-text>
                            <strong>{{ dogleg.inclLower }}</strong>&deg;
                        </b-col>
                    </b-row>
                    <b-row class="mt-2">
                        <b-col md="12">
                            <b-form-text>Dogleg Severity</b-form-text>
                            <strong>{{ dogleg.severity }}</strong>&deg;
                        </b-col>
                        <b-col v-if="dogleg.severity > 15" md="12" class="mt-2">
                            <b-alert variant="danger" style="padding: 0.5rem; margin-bottom: 0" show>
                                <strong>Warning!</strong> Dogleg severity is greater than 15&deg; per 100 ft!
                            </b-alert>
                        </b-col>
                    </b-row>
                </b-card> -->
                <b-card>
                    <h4 class="strong">Well Trajectory</h4>
                    <hr />
                    <scatter-chart :chartData="chartData" :options="chartOptions" style="height: 3000px !important"></scatter-chart>
                    <!-- <b-btn variant="primary" v-b-modal.modal-chart>Chart</b-btn> -->
                </b-card>
                <b-modal id="modal-chart" size="xl" scrollable>
                    
                </b-modal>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import ScatterChart from '../components/ScatterChart'

export default {
    name: 'trajectory',
    components: {
        ScatterChart
    },
    data() {
        return {
            caseId: null,
            md: null,
            tvd: null,
            conversion: 0,
            source: null,
            dest: null,
            maxAngle: 0,
            unit: "ft",
            type: "",

            isGenerating: false,
            isChartGenerated: false,

            dogleg: {
                mdUpper: 0,
                mdLower: 0,
                inclUpper: 0,
                inclLower: 0,
                severity: 0
            },

            fields: [
                { key: "caseId", label: "Case OD", class: 'text-right' },
                { key: "md", label: "MD", class: 'text-right' },
                { key: "tvd", label: "TVD", class: 'text-right' },
                { key: "dls", label: "DLS", class: 'text-right' },
                { key: "action", label: "", class: 'text-right' }
            ],
            items: [
                // { md: 100, tvd: 100, angle: "-" },
                // { md: 500, tvd: 495, angle: "-" },
                // { md: 1000, tvd: 975, angle: "-" },
                // { md: 2000, tvd: 1900, angle: "-" },
                // { md: 3000, tvd: 2700, angle: "-" },
                // { md: 4000, tvd: 3400, angle: "-" },
                // { md: 4500, tvd: 3800, angle: "-" },
                // { md: 5000, tvd: 4225, angle: "-" },
                // { md: 5500, tvd: 4675, angle: "-" },
                // { md: 6000, tvd: 5150, angle: "-" },
                // { md: 7000, tvd: 6125, angle: "-" },
                // { md: 8000, tvd: 7110, angle: "-" },
                // { md: 9000, tvd: 8105, angle: "-" },
                // { md: 10000, tvd: 9102, angle: "-" },
                // { md: 11000, tvd: 10102, angle: "-" },
            ],

            chartData: {},
            chartOptions: {}
        }
    },
    computed: {

        sortedItems() {
            return this.items.sort((a, b) => a.md - b.md)
        }

    },
    methods: {

        didTapInsert() {

            if(this.type == "Vertical") { this.tvd = this.md }

            if(this.md == null || this.tvd == null) { return }

            let newData = { caseId: this.caseId || undefined, md: this.md, tvd: this.tvd, dls: "-" }

            if(!this.items.map((item) => { return item.md }).includes(newData.md)) {
                this.items.push(newData)
                this.$refs.caseId.focus()

                this.caseId = null
                this.md = null
                this.tvd = null
            }

        },

        didTapRemove(target) {
            this.items = this.items.filter(item => {
                return !(item.md == target.md && item.tvd == target.tvd)
            })
        },

        didTapGenerateChart(requireSaving) {

            // let data = []
            let chartData = []
            var highestDegIndex = 0
            var currentCaseId = 0

            this.maxAngle = 0
            this.unit = this.$core.general.unit

            let multiplier = this.unit == "ft" ? 1 : 3.281
            this.items = this.items.sort((a, b) => a.md - b.md)

            chartData.push({ x: 0, y: 0, caseId: undefined })

            for(var i = 0; i < this.items.length; i++) {

                let item = this.items[i]
                item.dls = "-"

                // Zero index is ignored
                if(i == 0) {
                    
                    // Check if the first index has a case ID assigned. If not, abort and warn user
                    if(item.caseId == null || item.caseId == "") {
                        this.$helper.toastError(this, "The first dataset must have a case OD assigned!")
                        return
                    }

                    currentCaseId = item.caseId
                    chartData.push({ x: 0, y: item.tvd * -1, caseId: item.caseId })
                    continue

                }

                // Check if current item has no case ID, or lower case ID than previous set. Warn if larger.
                if(item.caseId != null && item.caseId != "") {

                    if(item.caseId > currentCaseId) {
                        this.$helper.toastError(this, "Case ODs must be lower than their previous Case OD!")
                        return
                    }

                    currentCaseId = item.caseId

                }

                let before = this.items[i - 1]
                let angle = Math.acos((item.tvd * multiplier - before.tvd * multiplier) / (item.md * multiplier- before.md * multiplier)) * 180 / Math.PI
                let roundifiedAngle = this.$helper.roundify(angle)

                if(Number(roundifiedAngle) > this.maxAngle) {
                    highestDegIndex = i
                    this.maxAngle = roundifiedAngle
                }

                item.angle = roundifiedAngle
                // data.push([item.md, item.tvd, roundifiedAngle])

                let x = +chartData[i].x + (item.tvd * multiplier - before.tvd * multiplier) * Math.sin(Math.PI / 180 * angle)
                chartData.push({ x: this.$helper.roundify(x), y: item.tvd * -1, caseId: item.caseId })

                // -- Calculate DLS of the previous iteration --
                // Skips 1-index as it cannot be calculated on its iteration
                if(i == 1) { continue }

                // DLS Calculation
                let dls = Math.acos(
                    (Math.cos(before.angle * Math.PI / 180) * Math.cos(roundifiedAngle * Math.PI / 180)) +
                    (Math.sin(before.angle * Math.PI / 180) * Math.sin(roundifiedAngle * Math.PI / 180))
                ) * 180 / Math.PI * (100 / (item.md - before.md))

                before.dls = this.$helper.roundify(dls)

            }

            // Calculate Dogleg
            // this.dogleg.mdUpper = this.items[highestDegIndex].md
            // this.dogleg.mdLower = this.items[highestDegIndex + 1].md
            // this.dogleg.inclUpper = this.items[highestDegIndex].angle
            // this.dogleg.inclLower = this.items[highestDegIndex + 1].angle

            // let severity = Math.acos(
            //     (Math.cos(this.dogleg.inclUpper * Math.PI / 180) * Math.cos(this.dogleg.inclLower * Math.PI / 180)) +
            //     (Math.sin(this.dogleg.inclUpper * Math.PI / 180) * Math.sin(this.dogleg.inclLower * Math.PI / 180))) *
            //     180 / Math.PI * (100 / (this.dogleg.mdLower * multiplier - this.dogleg.mdUpper * multiplier)
            // )

            // this.dogleg.severity = this.$helper.roundify(severity)

            // Check if save is not required
            if(!requireSaving) {
                this.updateChartData(chartData)
                return
            }

            // Save, then draw chart
            let payload = {
                calculationId: this.$core.id,
                trajectory: this.items
            }

            this.isGenerating = true
            this.$axios.post("/calc/saveTrajectory", payload).then(response => {

                let res = response.data

                if(res.message == "OK") {
                    this.$helper.toastSuccess(this, "Trajectory successfully saved!")
                    this.$core.trajectory = this.items
                    this.updateChartData(chartData)
                }
                else {
                    this.$helper.toastError(this, res.message)
                }

            })
            .catch(() => {
                this.$helper.toastError(this, "Failed to generate chart, please wait a moment and retry!")
            })
            .finally(() => {
                this.isGenerating = false
            })

        },

        updateChartData(chartData) {

            this.isChartGenerated = true
            let unit = this.unit

            this.chartOptions = {
                responsive: true,
                maintainAspectRatio: false,
                scales: {
                    xAxes: [{
                        id: 'horizontalDistance',
                        scaleLabel: {
                            display: true,
                            labelString: `Horizontal Distance (${unit})`
                        },
                        ticks: {
                            stepSize: 500,
                            beginAtZero: true
                        }
                    }],
                    yAxes: [{
                        id: 'tvd',
                        scaleLabel: {
                            display: true,
                            labelString: `TVD (${unit})`
                        },
                        ticks: {
                            beginAtZero: false,
                            stepSize: 500,
                            userCallback: function(label, index, labels) {
                                return label * -1
                            }
                        }
                    }]
                },
                legend: {
                    display: true,
                    labels: {
                        filter: function(item, chart) {
                            return !item.text.includes('UNUSED')
                        }
                    }
                },
                title: {
                    display: false
                },
                tooltips: {
                    intersect: false,
                    filter: function (tooltipItem) {
                        return tooltipItem.datasetIndex == 0
                    },
                    callbacks: {
                        label: function(tooltipItem, data) {
                            var datum = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index]
                            var md = datum.x
                            var tvd = datum.y * -1
                            var caseId = datum.caseId

                            if(caseId === undefined) {
                                return `Distance: ${md}, TVD: ${tvd}`
                            }
                            else {
                                return `Case OD: ${caseId}", Distance: ${md}, TVD: ${tvd}`
                            }

                        }
                    }
                }
            }

            // Setup PSD point
            let psd = this.$core.input.psd * -1
            let maxX = chartData[chartData.length - 1].x

            // Setup pipe illustration
            var numberOfCases = chartData.filter(cht => cht.caseId !== undefined).length + 1
            var lastCaseId = null
            var leftWallChart = []
            var rightWallChart = []
            var skewedChartData = []
            var caseChartLine = []

            // For vertical wells with 0 maxX
            if(maxX == 0) { maxX = 1000 }
            let space = maxX / 10 * numberOfCases
            let elbow = space / numberOfCases
            let indexCase = numberOfCases

            for(let cht of chartData) {

                leftWallChart.push({ x: +cht.x - (indexCase * elbow), y: cht.y })
                rightWallChart.push({ x: +cht.x + (indexCase * elbow), y: cht.y })

                if(cht.caseId !== undefined && lastCaseId != cht.caseId) { // New dataset

                    // Simulate smaller gap
                    indexCase--
                    leftWallChart.push({ x: +cht.x - (indexCase * elbow), y: cht.y })
                    rightWallChart.push({ x: +cht.x + (indexCase * elbow), y: cht.y })

                    caseChartLine.push({
                        backgroundColor: '#ffa500', borderColor: '#ffa500',
                        lineTension: 0, borderWidth: 2, pointRadius: 0, borderDash: [5, 5],
                        showLine: true, fill: false, label: 'UNUSED',
                        data: [
                            { x: +cht.x - (indexCase * elbow), y: cht.y, caseId: cht.caseId },
                            { x: +cht.x + (indexCase * elbow), y: cht.y, caseId: cht.caseId }
                        ]
                    })

                    lastCaseId = cht.caseId

                }

            }

            // The base dataset
            let baseDataset = [
                {
                    backgroundColor: '#757dd9', borderColor: '#757dd9',
                    lineTension: 0.2, borderWidth: 2, pointRadius: 2, borderDash: [5, 5],
                    showLine: true, fill: false, label: 'Trajectory Line',
                    data: chartData
                },
                {
                    backgroundColor: '#f87979', borderColor: '#f87979',
                    lineTension: 0, borderWidth: 2, borderDash: [5, 5], pointRadius: 0,
                    showLine: true, fill: false, label: `PSD (${psd * -1} ${unit})`,
                    data: [
                        { x: 0, y: psd },
                        { x: maxX * 1.2, y: psd }
                    ]
                },
                {
                    backgroundColor: '#757dd9', borderColor: '#757dd9',
                    lineTension: 0.2, borderWidth: 2, pointRadius: 0,
                    showLine: true, fill: false, label: 'UNUSED',
                    data: leftWallChart
                },
                {
                    backgroundColor: '#757dd9', borderColor: '#757dd9',
                    lineTension: 0.2, borderWidth: 2, pointRadius: 0,
                    showLine: true, fill: false, label: 'UNUSED',
                    data: rightWallChart
                }
            ]

            this.chartData = {
                 datasets: [...baseDataset, ...caseChartLine]
            }

        },

        didChangeConversion() {
            this.source = null
            this.dest = null
        },

        didTapCalculate() {

            if(this.items.length == 0) { 
                this.dest = "Not found"
                return
            }

            if(this.conversion == 0) { // MD to TVD

                let mds = this.items.map(item => { return item.md })
                let min = Math.min(...mds)
                let max = Math.max(...mds)

                if(this.source <= min || this.source >= max) {
                    this.dest = "Not found"
                    return
                }

                var temp = [...this.items]
                temp.push({ md: this.source, tvd: 0 })
                temp = temp.sort((a, b) => a.md - b.md)

                // Find index with source
                let lower = {}
                let upper = {}
                for(var i = 0; i < temp.length; i++) {
                    if(temp[i].md == this.source) {
                        lower = temp[i - 1]
                        upper = temp[i + 1]
                    }
                }

                let tvd = +lower.tvd + (this.source - lower.md) * (upper.tvd - lower.tvd) / (upper.md - lower.md)
                this.dest = this.$helper.roundify(tvd)

            }
            else { // TVD to MD

                let tvds = this.items.map(item => { return item.tvd })
                let min = Math.min(...tvds)
                let max = Math.max(...tvds)

                if(this.source <= min || this.source >= max) {
                    this.dest = "Not found"
                    return
                }

                var temp = [...this.items]
                temp.push({ md: 0, tvd: this.source })
                temp = temp.sort((a, b) => a.tvd - b.tvd)

                // Find index with source
                let lower = {}
                let upper = {}
                for(var i = 0; i < temp.length; i++) {
                    if(temp[i].tvd == this.source) {
                        lower = temp[i - 1]
                        upper = temp[i + 1]
                    }
                }

                let md = lower.md + (this.source - lower.tvd) * (upper.md - lower.md) / (upper.tvd - lower.tvd)
                this.dest = this.$helper.roundify(md)

            }

        }

    },
    created() {

        this.type = this.$core.general.type
        
        if(this.$core.trajectory instanceof Array) {

            this.items = this.$core.trajectory

            // Get maximum angle
            for(let item of this.items) {
                this.maxAngle = Math.max(this.maxAngle, item.angle)
            }

            // Draw graph
            this.didTapGenerateChart(false)

        }

    },
    beforeRouteLeave(to, from, next) {
        next()
    }
}
</script>

<style scoped>
    .alignMiddle >>> td {
        vertical-align: middle !important;
    }
</style>